import React, { useEffect } from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { ModalProvider } from "@/lib/modal";
import { captureAttribution } from "@/lib/attribution";
import Home from "@/pages/Home";
import Book from "@/pages/Book";
import BookSuccess from "@/pages/BookSuccess";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import NewsletterModal from "@/components/NewsletterModal";
import { Toaster } from "@/components/ui/sonner";

function Router() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/book" element={<Book />} />
            <Route path="/book/success" element={<BookSuccess />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
        </Routes>
    );
}

function App() {
    useEffect(() => {
        document.documentElement.classList.add("dark");
        captureAttribution();
    }, []);
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <ModalProvider>
                        <Router />
                        <NewsletterModal />
                        <Toaster theme="dark" position="bottom-right" />
                    </ModalProvider>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
